export default [
  {
    path: '/version/management',
    name: 'VersionManage',
    component: resolve => require(['@/views/VersionManage'], resolve),
    meta: {
      keepAlive: true // 需要被缓存
    }
  },
  // 新增-编辑
  {
    path: '/version/modify-form',
    name: 'VersionEC',
    component: resolve => require(['@/views/VersionManage/Form/Form'], resolve)
  }
]
